import { imageApplyDataAttr } from './helpers.js'

const articles = document.querySelectorAll('article.article')

/**
 * Init the abstacts
 */
function init() {
    //observer
    const observer = new IntersectionObserver(entries => {
        entries.forEach(({ isIntersecting, target }) => {

            if (isIntersecting && !target.classList.contains('active')) {

                const picture = target.querySelector('picture')
                const image = picture.querySelector('img')

                if (image) {
                    imageApplyDataAttr(image, ({ target }) => {
                        target.classList.add('active')
                    })
                }

                target.classList.add('active')
            }
        })
    })

    //observer
    articles.forEach(article => {
        observer.observe(article)
    })

}

export default {
    init,
}

